import { Box } from '@coolblue-development/freddy';
import styled from '@emotion/styled';
// This is a temporary fix to be able to show the reviews element before we have the matching component
export const StyledReviewsWrapper = styled(Box) `
  div > div:nth-of-type(2) > div {
    grid-column: span 12 !important;
  }

  a {
    display: none !important;
  }
`;
//# sourceMappingURL=MiniProductPage.styled.js.map